document.addEventListener('turbolinks:load', function () {
    if ($('.ce_reinspections.new, .ce_reinspections.create, .ce_reinspections.edit, .ce_reinspections.update').length === 0) {
        return false
    }

    $(document).on('change', '#ce_reinspection_report_type', function () {
        let reportType = $(this).val()
        let otherReportTypeField = $('#otherReportTypeField')

        if (reportType && reportType === 'Other') {
            $(otherReportTypeField).removeClass('d-none')
        } else {
            $(otherReportTypeField).addClass('d-none')
        }
    })
});